export const ProductBaseURL = '/api/products/'

export const UserBaseURL = '/api/users/'